
export const articlesdata = [
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color1",
        theme_name: "Work",
        title: "Mastering React.js: Tips, Tricks, and Best Practices",
        text: "It discusses the advantages of using React.js for web development, such as its flexibility...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color2",
        theme_name: "Work",
        title: "The Impact of Social Media on Mental Health",
        text: "This card has supporting text below as a natural lead-in to additional content...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color3",
        theme_name: "News",
        title: "The Importance of Self-Care",
        text: "This blog post emphasizes the importance of self-care in promoting mental...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color4",
        theme_name: "Photograph",
        title: "The Future of Web Design: Trends to Watch in 2023",
        text: "The post highlights the growing importance of mobile-friendly designs, voice-enabled...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color5",
        theme_name: "Photograph",
        title: "Building a Robust Admin Panel with Angular",
        text: "The post covers the key features and components of an effective admin panel...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color6",
        theme_name: "Technology",
        title: "'I cried when asked to be cover model'",
        text: "This card has supporting text below as a natural lead-in to additional content...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color1",
        theme_name: "Sports",
        title: "'I cried when asked to be cover model'",
        text: "This card has supporting text below as a natural lead-in to additional content...",
        last_update: "Last updated 13 mins ago",
    },
    {
        img: "assets/images/gallery/1.jpg",
        theme_color: "theme-color3",
        theme_name: "Design",
        title: "'I cried when asked to be cover model'",
        text: "This card has supporting text below as a natural lead-in to additional content...",
        last_update: "Last updated 13 mins ago",
    },
]